
export const actionTypes = {
    RequestMessageDetail: "[Request Message Detail] Action",
    LoadMessageDetail: "[Load Message Detail] Action",
    LoadMessageDetailSuccess: "[Load Message Detail Success] Action",
    LoadMessageDetailFailed: "[Load Message Detail Failed] Action",
    SetSearchString: "[Set Search String] Action",
  };
  
  //dispatch actions
  export const actions = {
    requestMessageDetail:(token, paramaterStr)=>({
      type: actionTypes.RequestMessageDetail,
      payload: { token:token , paramaterStr: paramaterStr},
    }),

    LoadMessageDetailSuccess:(data)=>({
      type: actionTypes.LoadMessageDetailSuccess,
      payload: { data },
    }),

    LoadMessageDetailFailed:(msg)=>({
      type: actionTypes.LoadMessageDetailFailed,
      payload: {msg}
    }),

    setSearchString:(data)=>({
      type: actionTypes.SetSearchString,
      payload: { data },
    }),
  };
  
  